import React from "react";
import { ControlLabel, Button, Alert } from "react-bootstrap";
import DatePicker from "react-bootstrap-date-picker";
import ReportsParameterSortBy from "./reports-parameter-sortby.jsx"; 
import ReportsParameterOffice from "./reports-parameter-office.jsx"; 
import ReportsParameterStatus from "./reports-parameter-status.jsx"; 
import ReportsParameterType from "./reports-parameter-type.jsx";
import ReportsParameterEmployeeName from "./reports-parameter-employeename.jsx";
import ReportsParameterCompany from "./reports-parameter-company.jsx";
import ReportsViewer from "./reports-viewer.jsx";
import ajax from "./../../lib/ajax.js";
import context from "./../../lib/context.js";
import moment from "moment";

export default class ReportsTimecardActivity extends React.Component {
    constructor(props) {
        super(props);
        var dateToday = new Date().toISOString();

        this.state = {
            startDate: dateToday,
            endDate: dateToday,
            office: "",
            peopleId: "",
            employeeName: "",
            status: "",
            type: "",
            state: "",
            sortBy: "approver",
            companies: "",
            errors: [],
            pdfUrl: ''
        }

        this.onRunReport = this.onRunReport.bind(this);
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handleOfficeChange = this.handleOfficeChange.bind(this);
        this.handleStatusChange = this.handleStatusChange.bind(this);
        this.handleSortByChange = this.handleSortByChange.bind(this);
        this.handleTypeChange = this.handleTypeChange.bind(this);
        this.handleEmployeeNameChange = this.handleEmployeeNameChange.bind(this);
        this.handleCompanyChange = this.handleCompanyChange.bind(this);
        this.loadReportViewModel = this.loadReportViewModel.bind(this);
        this.isAndroid = this.isAndroid.bind(this);
        this.isIos = this.isIos.bind(this);

        this.loadReportViewModel();
    }

    componentDidMount() {
        this.setState({
            startDateValue: this.getFormattedDate("startdate-datepicker"),
            endDateValue: this.getFormattedDate("enddate-datepicker")
        });
    }

    loadReportViewModel() {
        let self = this;

        context.message({
            show: true, 
            type: "loading", 
            message:"Loading. Please wait..."
        });

        ajax.vm().get(this.props.role + "/reports-timecard-activity")
            .then(function (res) {
                self.setState({
                    reportCode: res.data.reportCode,
                    keys: res.data.keys,
                    connection: res.data.connection,
                    role: res.data.role,
                    id: res.data.id,
                    username: res.data.username,
                    requiredLabel: res.data.requiredLabel,
                    startDateLabel: res.data.startDateLabel,
                    endDateLabel: res.data.endDateLabel,
                    officeLabel: res.data.officeLabel,
                    associateNameLabel: res.data.associateNameLabel,
                    statusLabel: res.data.statusLabel,
                    typeLabel: res.data.typeLabel,
                    sortByLabel: res.data.sortByLabel,
                    companyLabel: res.data.companyLabel,
                    runReportLabel: res.data.runReportLabel,
                    invalidStartDateLabel: res.data.invalidStartDateLabel,
                    invalidEndDateLabel: res.data.invalidEndDateLabel,
                    invalidDateRangeLabel: res.data.invalidDateRangeLabel
                });

                context.message({ show: false });
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    onRunReport() {
        var messages = this.validate();
        this.setState({
            errors: messages
        })

        if (messages.length == 0) {
            this.runReport();
        }
    }

    runReport() {
        console.log("RUN REPORT");
        let self = this;
        var values =
            self.state.connection + "|" +
            self.state.status + "|" +
            self.state.startDateValue + "|" +
            self.state.endDateValue + "|" +
            self.state.peopleId + "|" +
            self.state.sortBy + "|" +
            self.state.office + "|" +
            self.state.employeeName + "|" +
            self.state.id + "|" +
            self.state.role.replace('-', '') + "|" +
            self.state.state + "|" +
            self.state.type + "|" +
            self.state.username + "|" +
            self.state.companies;

        context.message({
            show: true, 
            type: "loading", 
            message:"Loading. Please wait..."
        });

        var params = {
            ReportCode: self.state.reportCode,
            Keys: self.state.keys,
            Values: values
        };

        var isAndroid = this.isAndroid();
        var isIos = this.isIos();

        // Open only for desktop
        if (isAndroid == false && isIos == false) {
            var myWindow = window.open("", "_blank");
            myWindow.document.write("<div id='divLoadMessage'>Please wait while report is loading...</div>");
        }

        ajax.api().put(`save-report`, params)
            .then(function (res) {
                if (isAndroid || isIos) {
                    self.setState({
                        pdfUrl: res.data.filePath
                    });
                    setTimeout(function() {
                        document.getElementById('aMobileOpener').click();
                    }, 10);
                } else {
                    myWindow.document.write("<script type='text/javascript'>document.getElementById('divLoadMessage').style.display = 'none';</script>");
                    myWindow.document.write("<iframe src='" + res.data.filePath + "' style='width: 100%; height: 100%;'></iframe>");
                }
                context.message({ show: false });
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
                if (isAndroid == false && isIos == false) {  
                    myWindow.close();
                }
            });
    }

    isAndroid() {
        var ua = navigator.userAgent.toLowerCase();
        return ua.indexOf("android") > -1;
    }

    isIos() {
        var ua = navigator.userAgent.toLowerCase();
        return ua.indexOf('ipad') > - 1 || ua.indexOf('iphone') > -1;
    }

    validate() {
        let msg = [];

        var startDate = this.getFormattedDate("startdate-datepicker");
        if (startDate.length == 0) {
            msg.push(this.state.invalidStartDateLabel);
            this.setState({
                startDate: null
            });
        }

        var endDate = this.getFormattedDate("enddate-datepicker");
        if (endDate.length == 0) {
            msg.push(this.state.invalidEndDateLabel);
            this.setState({
                endDate: null
            });
        }

        if (startDate.length > 0 && endDate.length > 0) {
            if ((new Date(startDate)) > new Date(endDate)) {
                msg.push(this.state.invalidDateRangeLabel);
            }
        }

        return msg;
    }

    getFormattedDate(id) {
        // accessed value from dom because handle change isn't fired when removed
        //return document.getElementById(id).getAttribute("data-formattedvalue").trim(); 
        return moment(document.getElementById(id).getAttribute("value").trim()).format("MM/DD/YYYY");
    }

    handleStartDateChange(value, formattedValue) {
        this.setState({
            startDate: value,
            startDateValue: moment(value).format("MM/DD/YYYY")
        });
    }

    handleEndDateChange(value, formattedValue) {        
        this.setState({
            endDate: value,
            endDateValue: moment(value).format("MM/DD/YYYY")
        });
    }

    handleOfficeChange(officeValue) {
        this.setState({
            office: officeValue
        });
    }

    handleEmployeeNameChange(peopleId, employeeName, state) {
        this.setState({
            peopleId: peopleId,
            employeeName: employeeName,
            state: state
        });
    }

    handleStatusChange(statusValue) {
        this.setState({
            status: statusValue
        });
    }

    handleTypeChange(typeValue) {
        this.setState({
            type: typeValue
        });
    }

    handleSortByChange(sortByValue) {
        this.setState({
            sortBy: sortByValue
        });
    }

    handleCompanyChange(value) {
        this.setState({
            companies: value
        });
    }

    render() {
        var rowStyle = {
            "padding-top": "10px"
        };

        var requiredStyle = {
            "color": "red"
        };

        var displayNone = {
            "display": "none"
        };

        let company = null;
        if (this.props.role == 'payroll-admin') {
            company = 
                <div className="col-md-6 col-lg-6">
                    <div className="col-md-12 col-lg-12">
                        <ControlLabel className="ap-report-control-label">{this.state.companyLabel}:</ControlLabel>
                    </div>
                    <div className="col-md-12 col-lg-12">
                        <ReportsParameterCompany onChange={this.handleCompanyChange} />
                    </div>
                </div>;
        }
        else {
            company = <div></div>;
        }

        return (
            <div className="container-fluid">
                <a id="aMobileOpener" href={this.state.pdfUrl} style={displayNone}></a>
                <div className="row">
                    <div className="col-md-12 col-lg-12">
                        <div className="col-md-12 col-lg-12">
                            <ControlLabel className="ap-report-control-label"><i className="fa fa-caret-right" style={requiredStyle}></i>-{this.state.requiredLabel}</ControlLabel>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 col-lg-6">
                        <div className="col-md-12 col-lg-12">
                            <ControlLabel className="ap-report-control-label">{this.state.startDateLabel}: <i className="fa fa-caret-right" style={requiredStyle}></i></ControlLabel>
                        </div>
                        <div className="col-md-12 col-lg-12">
                            <DatePicker id="startdate-datepicker" placeholder="MM/DD/YYYY" value={this.state.startDate}                                
                                onChange={this.handleStartDateChange}
                                onInput={this.handleStartDateChange} />
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-6">
                        <div className="col-md-12 col-lg-12">
                            <ControlLabel className="ap-report-control-label">{this.state.endDateLabel}: <i className="fa fa-caret-right" style={requiredStyle}></i></ControlLabel>
                        </div>
                        <div className="col-md-12 col-lg-12">
                            <DatePicker id="enddate-datepicker" placeholder="MM/DD/YYYY" value={this.state.endDate}                                
                                onChange={this.handleEndDateChange}
                                onInput={this.handleEndDateChange} />
                        </div>
                    </div>
                </div>
                <div className="row" style={rowStyle}>
                    <div className="col-md-6 col-lg-6">
                        <div className="col-md-12 col-lg-12">
                            <ControlLabel className="ap-report-control-label">{this.state.officeLabel}:</ControlLabel>
                        </div>
                        <div className="col-md-12 col-lg-12">
                            <ReportsParameterOffice onChange={this.handleOfficeChange} role={this.props.role} />
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-6">
                        <div className="col-md-12 col-lg-12">
                            <ControlLabel className="ap-report-control-label">{this.state.associateNameLabel}:</ControlLabel>
                        </div>
                        <div className="col-md-12 col-lg-12">
                            <ReportsParameterEmployeeName role={this.props.role} onChange={this.handleEmployeeNameChange} />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 col-lg-6">
                        <div className="col-md-12 col-lg-12">
                            <ControlLabel className="ap-report-control-label">{this.state.statusLabel}:</ControlLabel>
                        </div>
                        <div className="col-md-12 col-lg-12">
                            <ReportsParameterStatus onChange={this.handleStatusChange} />
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-6">
                        <div className="col-md-12 col-lg-12">
                            <ControlLabel className="ap-report-control-label">{this.state.typeLabel}:</ControlLabel>
                        </div>
                        <div className="col-md-12 col-lg-12">
                            <ReportsParameterType onChange={this.handleTypeChange} />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 col-lg-6">
                        <div className="col-md-12 col-lg-12">
                            <ControlLabel className="ap-report-control-label">{this.state.sortByLabel}:</ControlLabel>
                        </div>
                        <div className="col-md-12 col-lg-12">
                            <ReportsParameterSortBy onChange={this.handleSortByChange} />
                        </div>
                    </div>
                    {company}
                </div>
                <div className="row">
                    <div className="col-md-4 col-lg-4">
                        <div className="col-md-12 col-lg-12">
                            <Button onClick={this.onRunReport} className="btn-info ap-fullsize" >{this.state.runReportLabel}</Button>
                        </div>
                    </div>
                </div>
                <div className="row" style={rowStyle}>
                    <div className="col-md-12 col-lg-12">
                        <div className="col-md-12 col-lg-12">
                            <Alert bsStyle="danger" className={this.state.errors.length > 0 ? "" : "ap-hidden"}>
                                <ul>
                                    {this.state.errors.map(m =>
                                        <li key={m}>{m}</li>)}
                                </ul>
                            </Alert>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}